import React, { useState } from 'react';
import { api, apiError } from '../../api/client';
import { Button } from '../ui';

export default function RequestHistory({ sessionId }) {
  const [bundles, setBundles] = useState([]);
  const [configuration, setConfiguration] = useState(null), [part, setPart] = useState('');
  const [items, setItems] = useState(null), [detail, setDetail] = useState(null), [error, setError] = useState('');
  const load = async () => {
    try { const result = await api.getLlmRequests(sessionId); setItems(result.items); setBundles(result.bundles || []); setError(''); }
    catch (failure) { setError(apiError(failure)); }
  };
  return <details onToggle={event => { if (event.currentTarget.open && items === null) load(); }}>
    <summary>Использованные инструкции и запросы моделей</summary>
    <p>Сохранённые запросы конкретных вызовов. Старые вызовы до обновления снимков не имеют. Внутренние инструкции ACP-инструмента здесь недоступны.</p>
    {bundles.some(item => item.capture_from === 'upgrade') && <p>Для запусков, существовавших до обновления, конфигурация закреплена при обновлении; использованные раньше инструкции неизвестны.</p>}
    {error && <p role="alert">{error}</p>}<Button onClick={load}>Обновить</Button>
    <ul>{bundles.map(run => <li key={run.id}>Запуск №{run.number} · конфигурация №{run.revision || 'неизвестна'}
      {run.revision && <Button onClick={async () => {
        try { const value = await api.getPromptVersion(run.revision); setConfiguration(value); setPart(value.entries[0]?.key || ''); setError(''); }
        catch (failure) { setError(apiError(failure)); }
      }}>Показать инструкции запуска №{run.number}</Button>}</li>)}</ul>
    {configuration && <div><p>Закреплённая конфигурация №{configuration.revision}</p>
      <label>Инструкция запуска<select aria-label="Инструкция запуска" className="form-control" value={part} onChange={event => setPart(event.target.value)}>
        {configuration.entries.map(entry => <option key={entry.key} value={entry.key}>{entry.key}</option>)}
      </select></label><pre className="prompt-preview">{configuration.entries.find(entry => entry.key === part)?.text}</pre></div>}
    {items?.length === 0 && <p>Сохранённых запросов пока нет.</p>}
    <ul>{items?.map(item => <li key={item.id}><Button onClick={async () => {
      try { setDetail(await api.getLlmRequest(item.id)); setError(''); } catch (failure) { setError(apiError(failure)); }
    }}>{new Date(item.created_at).toLocaleString('ru')} · {item.target} · {item.phase || item.transport}</Button></li>)}</ul>
    {detail && <div><p>Конфигурация: {detail.bundle_id}. Транспорт: {detail.transport}.</p>
      {detail.redacted && <p>Чувствительные данные и двоичные изображения заменены безопасными представлениями. Хеш относится к исходному запросу.</p>}
      <pre className="prompt-preview">{JSON.stringify(detail.payload, null, 2)}</pre>
      <p>Части инструкций: {detail.parts.join(', ')}</p></div>}
  </details>;
}
